import React, { useEffect } from "react";
import { connect } from "react-redux";
import Box from "@mui/material/Box";
import { getComplaintSlaBadgeCounts } from "modules/complaints/api/actions";

function ComplaintsSidebarBadges({ overdueCount, warningCount, getComplaintSlaBadgeCounts }) {
  useEffect(() => {
    getComplaintSlaBadgeCounts();
  }, [getComplaintSlaBadgeCounts]);

  if (!overdueCount && !warningCount) {
    return null;
  }

  const circleSx = {
    minWidth: 20,
    height: 20,
    px: 0.25,
    borderRadius: "50%",
    fontSize: 11,
    fontWeight: 600,
    color: "#fff",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
  };

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
      }}>
      {overdueCount > 0 && (
        <Box component="span" sx={{ ...circleSx, bgcolor: "error.main" }} title="Complaints past due (SLA)">
          {overdueCount}
        </Box>
      )}
      {warningCount > 0 && (
        <Box component="span" sx={{ ...circleSx, bgcolor: "warning.main" }} title="Complaints in SLA warning window">
          {warningCount}
        </Box>
      )}
    </Box>
  );
}

function mapState(state) {
  const counts = state.complaints?.slaBadgeCounts || { overdue: 0, warning: 0 };
  return {
    overdueCount: Number(counts.overdue) || 0,
    warningCount: Number(counts.warning) || 0,
  };
}

export default connect(mapState, { getComplaintSlaBadgeCounts })(ComplaintsSidebarBadges);
